export enum ChecklistEvents {
  CHECKLIST_EXPANDED = `checklist_expand`,
  COMPLETED_CHECKLIST_ITEM = `complete_checklist_item`,
  CHECKLIST_COMPLETED = `checklist_complete`,
  CHECKLIST_COMPLETED_TITLE = `Checklist Completed Reward`,
}
